import { Themed, useTheme } from '@sky-distribution/react-commons-ui/lib/ThemeProvider';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { addErrorI18nResources, ERROR_NS } from '../../config';
import { GeneralPage } from './GeneralPage.component';
import { GeneralPageProps } from './GeneralPage.types';

const GeneralError: FC<GeneralPageProps> = (props) => {
  const theme = useTheme();
  const { i18n } = useTranslation(ERROR_NS);

  if (!i18n.hasResourceBundle(i18n.language, ERROR_NS)) {
    addErrorI18nResources(i18n);
  }

  return (
    <Themed theme={theme}>
      <GeneralPage {...props}/>
    </Themed>
  );
};

export default GeneralError;
